// extracted by extract-css-chunks-webpack-plugin
module.exports = {"panel":"info-panel__panel--2ZAG8","offset-top":"info-panel__offset-top--19Z3C","offsetTop":"info-panel__offset-top--19Z3C","neutral":"info-panel__neutral--3JYnC"};